import React from 'react';
import IconProps from './IconProps';
import './Icons.css';

export default function Email(props: IconProps) {
    return (
        <div className="icon email">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                enable-background="new 0 0 24 24"
                height="24"
                viewBox="0 0 24 24"
                width="24"
            >
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <g>
                        <path 
                        fill={props.fill}
                        d="M20,4H4C2.9,4,2.01,4.9,2.01,6L2,18c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M19.6,8.25l-7.07,4.42 c-0.32,0.2-0.74,0.2-1.06,0L4.4,8.25C4.15,8.09,4,7.82,4,7.53c0-0.67,0.73-1.07,1.3-0.72L12,11l6.7-4.19 C19.27,6.46,20,6.86,20,7.53C20,7.82,19.85,8.09,19.6,8.25z" />
                    </g>
                </g>
            </svg>
        </div>
    );
}
